import {fetch} from "../../../utils/dataAccess";

export function getWmsAssociations(currentInventoryId, page = 1) {
    return new Promise((resolve, reject) => {
        fetch(`/wms_associations/?inventoryId=${currentInventoryId}&page=${page}&itemsPerPage=30`)
            .then((response) => {
                response.json().then((retrieved) => {
                    resolve({
                        response: retrieved["hydra:member"],
                        itemsCount: retrieved["hydra:totalItems"]
                    })
                })
            })
            .catch(error => reject(error))
    })
}

export function getWmsAssociationCreationData(currentInventoryId) {
    return new Promise((resolve, reject) => {
        fetch("/wms_associations/creationData/?inventoryId="+currentInventoryId)
            .then((response) => {
                response.json().then((retrieved) => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}

export function newAssociation(currentInventoryId, brand, retailer, category, firstPlace, secondPlace) {
    return new Promise((resolve, reject) => {
        fetch("/wms_associations", {
            method: "POST",
            headers: new Headers({'Content-Type': 'application/json'}),
            body: JSON.stringify({
                inventory: `/inventories/${currentInventoryId}`,
                firstPlace: `/w_m_s_places/${firstPlace}`,
                secondPlace: secondPlace ? `/w_m_s_places/${secondPlace}` : null,
                brand: brand ? `/brands/${brand}` : null,
                seller: retailer ? `/retailers/${retailer}` : null,
                category: category ? `/categories/${category}` : null
            })
        })
            .then((response) => {
                response.json().then((retrieved) => {
                    resolve(retrieved)
                })
            })
            .catch((error) => reject(error))
    })
}

export function modifyAssociation(associationId, currentInventoryId, brand, retailer, category , firstPlace, secondPlace) {
    return new Promise((resolve, reject) => {
        fetch(`/wms_associations/${associationId}`, {
            method: "PATCH",
            headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
            body: JSON.stringify({
                inventory: `/inventories/${currentInventoryId}`,
                brand: brand ? `/brands/${brand}` : null,
                seller: retailer ? `/retailers/${retailer}` : null,
                category: category ? `/categories/${category}` : null,
                firstPlace: `/w_m_s_places/${typeof firstPlace === 'object' ? firstPlace.barcode : firstPlace}`,
                secondPlace: secondPlace ? `/w_m_s_places/${typeof secondPlace === 'object' ? secondPlace.barcode : secondPlace}` : null,
            })
        })
            .then((response) => {
                response.json().then((retrieved) => {
                    resolve(retrieved)
                })
            })
            .catch((error) => reject(error))
    })
}

export function deleteAssociation(association) {
    return new Promise((resolve, reject) => {
        fetch(`/wms_associations/${association.id}`, {
            method: "DELETE"
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => reject(error))
    })
}
